import { SR_API_ACTION_UTILITY_ACTIVATION_GET_TYPES_LIST } from 'api/utilityActionTypes';

export default async function getTypesList({ state, utilityApiClient }) {
  const statePath = ['utilityActivations', 'types'];

  const typesCache = state.get(statePath);
  if (typesCache) {
    return typesCache;
  }

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET_TYPES_LIST,
    state: state,
    payload: {},
    onSuccess(utilityTypes) {
      if (utilityTypes) {
        state.set(statePath, utilityTypes);
        return utilityTypes;
      }
    },
  });
}
